import React from 'react';
import sloganImg from '../../registionActivity/images/GPremium-brand@2x.png'
import styles from './slogon.module.scss'
export const Slogan = (props)=>{
    const {className} = props;
    return  <div className={`${styles.container} ${className}`} >
                <img src={sloganImg}/>
            </div>
};
